<template>
  <div>
    <form @submit.prevent>
      <div id="tim-kiem-thong-tin" class="box-form">
        <div class="box-form-result">
          <p class="color-gray-1">Tìm thấy {{ totalRows }} kết quả</p>
          <DataTable
            :value="danhSachVaiTroNoiBo"
            :loading="isLoadingTable"
            :selection.sync="selectedVaiTro"
          >
            <Column
              field="id"
              headerStyle="width: 40px"
              header=""
              bodyStyle="text-align: center"
              selectionMode="multiple"
            >
            </Column>
            <Column
              field="stt"
              dataKey="stt"
              headerStyle="width: 40px"
              headerClass="p-2"
              header="STT"
              bodyStyle="text-align: center"
            >
              <template #filter> </template>
              <template #body="slotProps">
                <span>{{
                  (requestInformation.pageIndex - 1) *
                    requestInformation.pageSize +
                  slotProps.index +
                  1
                }}</span>
              </template>
            </Column>
            <Column
              filterMatchMode="custom"
              field="name"
              header="Tên vai trò"
              headerStyle="minWidth: 200px"
            >
              <template #filter>
                <InputText
                  type="text"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  v-model="requestForm.Name"
                  @change="layDanhSachVaiTro"
                />
              </template>
              <template #body="slotProps">
                <span>{{ slotProps.data.name }}</span>
              </template>
            </Column>
            <Column
              filterMatchMode="custom"
              field="displayName"
              header="Tên hiển thị"
              headerStyle="minWidth: 200px"
            >
              <template #filter>
                <InputText
                  type="text"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  v-model="requestForm.DisplayName"
                  @change="layDanhSachVaiTro"
                />
              </template>
              <template #body="slotProps">
                <span>{{ slotProps.data.displayName }}</span>
              </template>
            </Column>
            <Column
              filterMatchMode="custom"
              field="appName"
              header="Ứng dụng"
              headerStyle="minWidth: 200px"
            >
              <template #filter>
                <InputText
                  type="text"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  v-model="requestForm.AppName"
                  @change="layDanhSachVaiTro"
                />
              </template>
              <template #body="slotProps">
                <div v-html="slotProps.data.appName"></div>
              </template>
            </Column>
            <Column
              filterMatchMode="custom"
              field="thaoTac"
              header="Thao tác"
              headerStyle="width: 100px"
            >
              <template #body="slotProps">
                <div class="text-center">
                  <b-icon
                    icon="plus-circle-fill"
                    variant="success"
                    v-b-popover.hover.top="'Thêm vai trò vào nhóm'"
                    class="cursor-pointer color-red ml-2"
                    @click="
                      getTenVaiTro = slotProps.data.name;
                      themVaiTro(slotProps.data.roleId);
                    "
                  />
                </div>
              </template>
            </Column>
            <template #empty
              ><div class="text-center">Không có dữ liệu</div></template
            >
            <template #loading
              ><div class="text-center">Đang tải dữ liệu ...</div>
            </template>
          </DataTable>
          <BasePagination
            class="mt-3"
            :total-pages="danhSachVaiTro.totalPage"
            :total-rows="danhSachVaiTro.totalCount"
            :current-page="requestInformation.pageIndex"
            @changePages="onChangePages($event)"
            @changeNum="onChangeNum($event)"
          />
          <div style="text-align: center" class="float-right mt-4">
            <base-button
              :disabled="selectedVaiTro.length === 0"
              button="Thêm mới"
              size="sm"
              class="btn search-information-btn mb-3 mr-2"
              variant="primary"
              @click="themDanhSachVaiTroDaChon()"
              >Tạo</base-button
            >
            <base-button
              button="Đóng"
              size="sm"
              class="btn search-information-btn mb-3 mr-2"
              variant="outline-secondary"
              @click="hideModal()"
              >Hủy
            </base-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {
  ROUTE_NAME,
  MENU_ROUTE_NAME,
  BANG_VAI_TRO,
  BO_QUA_BUTTON_LABEL,
} from "@/constants/constants";
import { mapGetters } from "vuex";
import _isEmpty from "lodash/isEmpty";
import _isNil from "lodash/isNil";
import BasePagination from "@/components/common/BasePagination";

export default {
  name: "DanhSachVaiTroKhongThuocGroup",
  components: {
    BasePagination,
  },
  data() {
    return {
      MENU_ROUTE_NAME: `${MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.VAI_TRO}`,
      ROUTE_NAME: ROUTE_NAME,
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      requestInformation: {
        pageSize: 10,
        pageIndex: 1,
        filterBy: "",
      },
      totalRows: 0,
      isLoadingTable: true,
      deletedId: null,
      danhSachIdVaiTroDaChon: [],
      danhSachIdVaiTro: [],
      selectAllRowsInPage: false,
      emptyHeaderTable: [
        BANG_VAI_TRO.stt,
        BANG_VAI_TRO.name,
        BANG_VAI_TRO.displayName,
        BANG_VAI_TRO.appName,
        BANG_VAI_TRO.thaoTac,
      ],
      danhSachIdVaiTroThemMoi: [],
      getTenVaiTro: "",
      selectedVaiTro: [],
      requestForm: {},
    };
  },
  computed: {
    ...mapGetters({
      danhSachVaiTro: "role/danhSachVaiTroKhongThuocGroup",
      danhSachApp: "app/tatCaApp",
    }),
    danhSachVaiTroNoiBo() {
      return this.layDanhSachVaiTroNoiBo(this.danhSachVaiTro);
    },
    fieldName() {
      return this.getFieldName();
    },
    hasPageData() {
      return !_isEmpty(this.danhSachVaiTro);
    },
    danhSachVaiTroDaChon: {
      get: function () {
        let danhSachVaiTro = this.danhSachVaiTroNoiBo.filter((quyen) =>
          this.danhSachIdVaiTroDaChon.includes(quyen.Id)
        );

        return danhSachVaiTro.map((quyenDaChon, index) => {
          return Object.assign({}, quyenDaChon, {}, { stt: index + 1 });
        });
      },
      set: function () {},
    },
  },
  props: {
    groupId: {
      type: String,
      require: false,
    },
    appId: {
      type: String,
      require: false,
    },
  },
  watch: {
    danhSachVaiTro: {
      handler() {
        this.danhSachIdVaiTro = this.layDanhSachIdVaiTro(
          this.danhSachVaiTroNoiBo
        );
        this.totalPages = this.danhSachVaiTro.totalPage;
        this.totalRows = _isNil(this.danhSachVaiTro.totalCount)
          ? 0
          : this.danhSachVaiTro.totalCount;
        this.clickSelectAllRowInPage();
      },
      immediate: true,
    },
    selectAllRowsInPage: {
      handler() {
        this.clickSelectAllRowInPage();
      },
    },
    selectedVaiTro: {
      handler() {
        this.danhSachIdVaiTroDaChon = (this.selectedVaiTro || []).map(
          (x) => x.roleId
        );
      },
      deep: true,
    },
  },
  created() {
    this.layDanhSachVaiTro();
    this.layDanhSachApp();
  },
  methods: {
    async setTenVaiTro() {
      this.getTenVaiTro = "";
      await this.danhSachIdVaiTroDaChon.forEach((item) => {
        this.getTenVaiTro += this.getName(item) + ", ";
      });
      this.getTenVaiTro = this.getTenVaiTro.slice(0, -2);
    },
    getName(id) {
      const danhSachVaiTroNoiBo = this.danhSachVaiTroNoiBo || [];
      console.log(danhSachVaiTroNoiBo);
      let findItem = danhSachVaiTroNoiBo.find((item) => item.roleId == id);
      return findItem ? findItem.name : null;
    },
    onChangeNum(pageSize) {
      this.requestInformation.pageIndex = 1;
      this.requestInformation.pageSize = pageSize;
      this.layDanhSachVaiTro();
    },
    onChangePages(page) {
      this.requestInformation.pageIndex = page;
      this.layDanhSachVaiTro();
    },
    hideModal() {
      this.$emit("close");
    },
    layDanhSachApp() {
      this.$store.dispatch("app/layTatCaApp");
    },
    timDanhSachVaiTro() {
      this.layDanhSachVaiTro();
    },
    async themVaiTro(item) {
      this.danhSachIdVaiTroThemMoi = [item];
      this.$emit("themVaiTroVaoGroup");
    },
    async themDanhSachVaiTroDaChon() {
      this.danhSachIdVaiTroThemMoi = this.danhSachIdVaiTroDaChon;
      await this.setTenVaiTro();
      this.$emit("themVaiTroVaoGroup");
    },
    layDanhSachIdVaiTro(danhSachVaiTro) {
      if (_isEmpty(danhSachVaiTro)) {
        return [];
      }
      return danhSachVaiTro.map((item) => item.id);
    },
    clickSelectAllRowInPage() {
      if (this.selectAllRowsInPage) {
        this.$set(
          this,
          "danhSachIdVaiTroDaChon",
          this.danhSachIdVaiTroDaChon.concat(this.danhSachIdVaiTro)
        );
        this.$set(this, "danhSachIdVaiTroDaChon", [
          ...new Set(this.danhSachIdVaiTroDaChon),
        ]);
      } else {
        this.danhSachIdVaiTroDaChon = this.danhSachIdVaiTroDaChon.filter(
          (id) => !this.danhSachIdVaiTro.includes(id)
        );
      }
    },
    layDanhSachVaiTro() {
      const payload = {
        groupId: this.groupId,
        appId: this.appId,
        ...this.requestInformation,
        ...this.requestForm,
      };
      this.isLoadingTable = true;
      this.$store
        .dispatch("role/layDanhSachVaiTroKhongThuocGroup", payload)
        .then(() => {
          this.isLoadingTable = false;
        });
    },
    layDanhSachVaiTroNoiBo(danhSachVaiTro) {
      console.log(danhSachVaiTro);
      if (_isEmpty(danhSachVaiTro)) {
        return [];
      }
      return danhSachVaiTro.items.map((item, index) => {
        return {
          checkbox: null,
          stt:
            (this.requestInformation.pageIndex - 1) *
              this.requestInformation.pageSize +
            index +
            1,
          name: _isNil(item.name) ? "" : item.name,
          displayName: _isNil(item.displayName) ? "" : item.displayName,
          appName: _isNil(item.appName) ? "" : item.appName,
          id: item.id,
          roleId: item.roleId,
          thaoTac: null,
        };
      });
    },
    getFieldName() {
      if (_isEmpty(this.danhSachVaiTroNoiBo)) {
        return [];
      }
      return Object.keys(this.danhSachVaiTroNoiBo[0])
        .filter((key) => key !== "id")
        .map((key) => {
          return {
            key: key,
            label: BANG_VAI_TRO[key],
            tdClass: ["stt"].includes(key) ? "center" : "",
          };
        });
    },
  },
};
</script>


